/**
 * App-wide configuration constants.
 * Replace these with environment variables for production.
 */

/** Contact information */
export const CONTACT = {
  /** WhatsApp number (international format, no +) */
  WHATSAPP: import.meta.env.VITE_WHATSAPP_NUMBER || '84901234567',
  /** Zalo number */
  ZALO: import.meta.env.VITE_ZALO_NUMBER || '84901234567',
  /** Hotline number */
  HOTLINE: import.meta.env.VITE_HOTLINE_NUMBER || '02873008855',
  /** Hotline display format */
  HOTLINE_DISPLAY: '028 7300 8855',
  /** Company email */
  EMAIL: import.meta.env.VITE_CONTACT_EMAIL || 'hello@propico.vn',
} as const;

/** Company info */
export const COMPANY = {
  NAME: 'Propico',
  FULL_NAME: 'Propico Vietnam',
  WEBSITE: 'https://propico.vn',
} as const;
